<template>
  <v-card flat class="d-flex flex-column panel-card rounded-xl">
    <div class="d-flex text-h6 px-4">
      <div class="d-flex flex-column justify-start align-start py-0">
        <v-badge v-if="badgeValue > 0" :content="badgeValue" color="error" inline>
          <div class="mt-2">Infos</div>
        </v-badge>
        <div v-else class="mt-2">Infos</div>
      </div>
      <v-spacer></v-spacer>
      <div class="d-flex flex-column align-end mr-8 d-print-none" style="margin-top: 6px">
        <v-btn-toggle mandatory rounded v-model="infoDisplayMode" color="primary">
          <v-btn small value="active">nicht gelöschte </v-btn>
          <v-btn small value="all">alle </v-btn>
          <v-btn small value="deleted">gelöschte </v-btn>
        </v-btn-toggle>
      </div>
    </div>
    <div class="d-flex flex-column flex-grow-1 pa-0 info-feed-scroll">
      <v-list nav dense id="infoFeed">
        <v-list-item v-for="info in items" :key="info.id" class="my-0 py-0 item-bottom-border" :id="`info_${info.id}`">
          <v-list-item-avatar size="30">
            <v-avatar color="primary">
              <span class="white--text">{{ authorAbreviation(info) }}</span>
            </v-avatar>
          </v-list-item-avatar>

          <v-list-item-content>
            <div class="d-flex flex-column">
              <div>{{ info.remark }}</div>
              <v-badge v-if="info.receivedAt > 0" :content="info.changeType" right offset-x="40" offset-y="-4" color="error">
                <div class="text-small-grey">{{ info.authorFirstname }} {{ info.authorLastname }} am {{ getInfoTime(info) }}</div>
              </v-badge>
              <div v-else class="text-small-grey">{{ info.authorFirstname }} {{ info.authorLastname }} am {{ getInfoTime(info) }}</div>
            </div>
          </v-list-item-content>
          <v-list-item-action class="my-0">
            <v-btn x-small @click="toggleDeletedFlag(info)" small color="secondary" icon>
              <v-icon small>mdi-{{ info.deleted ? 'delete-off' : 'delete' }}</v-icon>
            </v-btn>
            <div class="text-small-grey">{{ info.deleted ? 'reaktivieren' : 'löschen' }}</div>
          </v-list-item-action>
        </v-list-item>
      </v-list>
      <div id="alwaysLastEl" style="padding-top: 50px; width: 100px; height: 10px; font-size: 0">Hello</div>
    </div>
    <v-card-actions @keydown.enter="sendItem">
      <div class="d-flex justify-center pt-0 px-2 full-width">
        <v-text-field style="width: calc(100% - 20px)" rounded outlined dense clearable v-model="newInfo" hide-details label="Neue Information"></v-text-field>
        <v-btn icon @click="sendItem">
          <v-icon>mdi-send</v-icon>
        </v-btn>
      </div>
    </v-card-actions>
  </v-card>
</template>

<script>
import { mapMutations, mapGetters, mapState } from 'vuex';
import dateUtils from '../../../../common/dateUtils';
import common from '@/mixins/common';
import dateTimeMixin from '@/mixins/dateTimeMixin';
import MODULE_ID from '../../moduleId';
import worksheetService from '@/modules/customerVbzWorksheet/worksheetService';
import constants from '../../constants';

const DOMAIN = 'information';
export default {
  mixins: [common, dateTimeMixin],
  props: {
    badgeValue: Number,
    badgeColor: String,
  },
  data() {
    return {
      newInfo: null,
      newItemArrived: false,
      infoDisplayMode: 'active',
    };
  },
  computed: {
    ...mapState('vbzWorksheet', ['informations']),
    ...mapState('vbzWorksheet', ['informationsByDate']),
    ...mapState('vbzWorksheet', {
      currentDate: (state) => state.contextDate,
    }),
    infosAtSelectedDay() {
      let deletedOnly = this.infoDisplayMode === 'deleted';
      let ignoreDeleted = this.infoDisplayMode === 'active';
      let currentDayKey = worksheetService.buildDateIdFromDate(this.currentDate);

      let infosCurrentDay = this.informationsByDate[currentDayKey];
      let dataFilterEnabled = false; //no data filtering required due to pre-filtering in infosCurrentDay

      let filtered = worksheetService.filterItems(this.currentDate, infosCurrentDay, deletedOnly, ignoreDeleted, 'date', dataFilterEnabled);
      return worksheetService.sortById(filtered);
    },

    unreadInfos() {
      return this.infosAtSelectedDay.filter((i) => i.deleted === false);
    },

    showReadInfoItems: {
      get() {
        return this.$store.state[MODULE_ID].showReadInfoItems;
      },
      set(value) {
        this.$store.commit(`${MODULE_ID}/set`, { property: 'showReadInfoItems', value });
      },
    },
    user() {
      return this.$store.state.profile.user;
    },
    items() {
      return this.infosAtSelectedDay;
    },
  },
  methods: {
    ...mapMutations('vbzWorksheet', ['pushDomainItem']),

    authorAbreviation(info) {
      let abbr = '';
      if (info.authorFirstname) abbr += info.authorFirstname.substr(0, 1);
      if (info.authorLastname) abbr += info.authorLastname.substr(0, 1);
      return abbr;
    },
    getInfoTime(info) {
      return dateUtils.formatDateTime(info.createdAt);
    },
    sendItem() {
      if (!this.newInfo) return;

      let currDate = new Date(this.currentDate.getTime());

      console.debug('currDate', currDate);

      let sendItem = {
        vbzNr: '' + this.user.employeeNr,
        remark: this.newInfo,
        authorFirstname: this.user.firstName,
        authorLastname: this.user.lastName,
        date: currDate.toISOString(),
      };
      console.debug('sendItemsendItem', sendItem);
      this.mx_scrollTo('alwaysLastEl');

      // send the new item to the server by socket.io
      this.$socket.emit('domain:create', DOMAIN, sendItem, (response) => {
        this.pushDomainItem({ domain: DOMAIN, item: response.data });
      });

      this.newInfo = null;
    },
    toggleDeletedFlag(info) {
      const DOMAIN = 'information';
      this.$socket.emit('domain:delete', DOMAIN, info, (response) => {
        info.deleted = response.softDeleted.deleted;
      });
    },
  },
  watch: {
    unreadInfos(newValue, oldValue) {
      if (newValue > oldValue) {
        setTimeout(() => (this.newItemArrived = false), 10000);
        this.newItemArrived = true;
      }
      this.$emit('updateUnreadCount', newValue.length);
    },
    infosAtSelectedDay(newValue, oldValue) {
      if (newValue.length > oldValue.length) {
        // scroll only when a new message arrives for the day currently selected
        this.mx_scrollTo('alwaysLastEl');
      }
    },
    items(newValue, oldValue) {
      setTimeout(() => {
        this.items.forEach((i) => {
          i.receivedAt = 0;
          i.changeType = null;
        });
      }, constants.showChangesDurationInSeconds * 1000);
    },
  },
};
</script>

<style>
.text-small-grey {
  font-size: 11px !important;
  color: grey !important;
}

.panel-card {
  transition: all ease-in-out 1s;
  overflow: visible;
  margin: 0 !important;
  width: 100%;
}

.info-feed-scroll {
  overflow-y: auto;
  scrollbar-width: thin;
  scrollbar-color: #90a4ae #eceff1;
}
</style>
